import { client } from '../client';
import { IVideo } from '../communication/types/IVideo';

export const joinVideoRoom = async (caseId: number): Promise<IVideo> => {
  const { data } = await client.post<IVideo>(`/cases/${caseId}/join_video_room`);

  return data;
};
